<template>
  <div class="af3-shortcodes-single-units-component">
    <div class="af3-shortcodes-single-units-component-header">
      <h2>{{ available_units.length }} Available {{ handleUnitsPlural() }}</h2>
    </div>
    <div class="af3-shortcodes-single-units-component-body">
      <table>
        <thead>
          <tr>
            <th v-if="options.single_floor_plan_show_site_map"></th>
            <th v-if="options.building_name">Building Name</th>
            <th>Unit Name</th>
            <th v-if="options.single_floor_plan_show_pricing">Starting At</th>
            <th>Available Date</th>
            <th>Deposit</th>
            <th>Apply</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="unit in available_units" :key="unit.id">
            <td v-if="options.single_floor_plan_show_site_map">
              <button @click="handleMapClick(unit)" class="af3-shortcodes-single-units-component-map-button">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="31.325" height="29.626" viewBox="0 0 31.325 29.626"><defs><clipPath id="a"><rect width="31.325" height="29.626" fill="none"/></clipPath></defs><g clip-path="url(#a)"><path d="M26.411,19.655a.775.775,0,0,0-.686-.4H20.558c2.24-3.288,4.48-7.262,4.48-9.863a9.376,9.376,0,1,0-18.751,0c0,2.565,2.276,6.576,4.48,9.863H5.672a.735.735,0,0,0-.686.4L.108,28.434a.783.783,0,0,0,0,.795.879.879,0,0,0,.723.4h29.7a.8.8,0,0,0,.795-.795.863.863,0,0,0-.181-.506ZM7.912,9.394a7.768,7.768,0,0,1,15.536,0c0,2.312-2.457,6.431-4.841,9.863-.4.542-.795,1.084-1.156,1.626-.65.867-1.265,1.662-1.77,2.312-.506-.65-1.12-1.409-1.77-2.312-.361-.506-.759-1.048-1.156-1.626-2.385-3.432-4.841-7.551-4.841-9.863M2.2,28l3.938-7.154h5.781c1.626,2.276,3,3.938,3.143,4.083a.827.827,0,0,0,.614.289.772.772,0,0,0,.614-.289c.145-.181,1.517-1.843,3.143-4.083h5.781L29.157,28Z" transform="translate(0)"/><path d="M40.321,19.61a4.01,4.01,0,1,0-4.01,4.01,4.025,4.025,0,0,0,4.01-4.01m-6.395,0a2.385,2.385,0,1,1,2.385,2.385,2.382,2.382,0,0,1-2.385-2.385" transform="translate(-20.63 -9.964)"/></g></svg>
                <span class="sr-only">View Map</span>
              </button>
            </td>
            <td v-if="options.building_name">{{ unit.building_name }}</td>
            <td>{{ unit.name }}</td>
            <template v-if="options.single_floor_plan_show_pricing">
              <td>{{ options.override_pricing ? options.override_pricing : (unit.price && !unit.price.toString().startsWith('$') ? '$' + unit.price : unit.price) }}</td>
            </template>
            <td>{{ unit.available_on }}</td>
            <td>{{ unit.deposit }}</td>
            <td><a :href="unit.apply_url" target="_blank">{{ options.floor_plans_loop_apply_button_label }}</a></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
  
<script>

import { defineComponent, ref, watch, onMounted, reactive  } from 'vue';


export default defineComponent({
    components: { },
    emits: ['select-unit'],
   
    props: {
        available_units: {
            type: [Array, Boolean],
            required: true
        },
        options: {
            type: Object,
            required: true
        },
        floor_plan: {
            type: Object,
            required: true
        }
    },

    setup(props, { emit }) {


      const handleUnitsPlural = () => {
        const label = props.options.single_floor_plan_units_label;
        if (props.available_units.length === 1) return label;
        
        // Handle common English pluralization rules
        if (label.endsWith('y')) {
          return label.slice(0, -1) + 'ies';
        } else if (label.endsWith('s') || label.endsWith('x') || label.endsWith('z') || label.endsWith('ch') || label.endsWith('sh')) {
          return label + 'es';
        } else {
          return label + 's';
        }
      }

      const handleMapClick = (unit) => {
        // scroll to the map
        const element = document.querySelector('.af3-shortcodes-floor-plan-page-main-component-tabs');
        const offset = element.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({ top: offset, behavior: 'smooth' });
        emit('select-unit', unit.name);
      }

          

    return {
        handleUnitsPlural,
        handleMapClick
    };
  },


  
  
});
</script>